module.exports = __webpack_public_path__ + "img/iso-45001.f98c873.png";